import { render, staticRenderFns } from "./emptyState.vue?vue&type=template&id=5aaff0f0&"
import script from "./emptyState.vue?vue&type=script&lang=js&"
export * from "./emptyState.vue?vue&type=script&lang=js&"
import style0 from "./emptyState.vue?vue&type=style&index=0&id=5aaff0f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports